import React from "react";
export default function Table_Resizing() {
  return <div>Excel_Table_Resizing</div>;
}
